import React from 'react'
// Node modules
import styled from 'styled-components'
// Layouts
import WelcomePageTitle from './WelcomePageTitle'
import WelcomePageRecord from './WelcomePageRecord'
import { useNavigate } from 'react-router'

const WelcomePageValidatedRecordsContainer = styled.div`
`

export default function WelcomePageValidatedRecords({ records, babysittingModes, isChildActive }) {
  const navigate = useNavigate()
  const declare = (recordId) => {
    navigate(`/declaration/${ recordId }`)
  }
  return (
    <WelcomePageValidatedRecordsContainer>

      { records && records.length > 0 &&
      <WelcomePageTitle margin="40px 0px 15px 20px" label="Mes déclarations mensuelles"/> }

      { records.map((record, index) => {
        const actionRecord = () => declare(record._id)
        return (
          <WelcomePageRecord
            key={ record._id }
            record={ record }
            babysittingModes={ babysittingModes }
            isChildActive={ isChildActive }
            actionRecord={ actionRecord }/>
        )

      }) }

    </WelcomePageValidatedRecordsContainer>
  )

}
